export const comments_3357260 = {"data":{"data":[],"links":{}}}